module.exports = __webpack_public_path__ + "static/media/bucket.ac0b16ab.svg";